import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

interface MetricCardProps {
  icon: React.ReactNode;
  label: string;
  value: string | number;
  trend?: {
    value: number;
    isPositive: boolean;
  };
}

const MetricCard: React.FC<MetricCardProps> = ({ icon, label, value, trend }) => {
  return (
    <Card className="hover:shadow-lg transition-shadow duration-200">
      <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2 px-3 sm:px-6">
        <CardTitle className="text-xs sm:text-sm font-medium text-muted-foreground truncate pr-2">
          {label}
        </CardTitle>
        <div className="text-primary flex-shrink-0">{icon}</div>
      </CardHeader>
      <CardContent className="px-3 sm:px-6">
        <div className="flex items-baseline justify-between">
          <div className="text-lg sm:text-2xl font-bold truncate">{value}</div>
          {trend && (
            <div className={`text-xs sm:text-sm ml-2 flex-shrink-0 ${
              trend.isPositive ? 'text-green-600' : 'text-red-600'
            }`}>
              {trend.isPositive ? '↑' : '↓'} {Math.abs(trend.value)}%
            </div>
          )}
        </div>
      </CardContent>
    </Card>
  );
};

export default MetricCard; 